import React,{useState} from 'react'
import './index.scss'
import {Button} from 'antd-mobile'
const RushBill = () => {
    let [isFlod,setFlod] = useState(true)
    const handleFlodPrice = () => {
        setFlod(true)
    }
    const handleUnflodPrice = () => {
        setFlod(false)
    }
    return (
        <div className='rushBill'>
            <p className="title">可抢单</p>
            <p className='time'>
                <i className='iconfont icon-time'></i>
                <span>11-24 13:15</span>
            </p>
            {/* 地址 */}
            <div>
                <div className="travel">
                    <div className="tip">
                        <div className="icon startIcon">起</div>
                        <span>12km</span>
                    </div>
                    <div className='address'>
                        <p className="addressTitle">光明大厦（未来路）</p>
                        <p>金水区与未来路交叉口西北角</p>
                    </div>
                    <div>
                        <i className='iconfont icon-dianji'></i>
                    </div>
                </div>
                <div className='travel'>
                    <div className="tip">
                        <div className="icon endIcon">终</div>
                        <span>12km</span>
                    </div>
                    <div className='address'>
                        <p className="addressTitle">光明国际（光明路）</p>
                        <p>金水区与未来路交叉口西北角</p>
                    </div>
                    <div>
                        <i className='iconfont icon-dianji'></i>
                    </div>
                </div>
            </div>
            <hr></hr>
            {/* 订单价格 */}
            <div>
                <div className="price">
                    <p className='title'>订单价格</p>
                    <b>
                        <span>￥</span>
                        50.00
                       {!isFlod && <i className='iconfont icon-jiantoushang' onClick={handleFlodPrice}></i>}
                       {isFlod &&  <i className='iconfont icon-jiantouxia' onClick={handleUnflodPrice}></i>}
                    </b>
                </div>
                {!isFlod && <ul className='info'>
                    <li>
                        <span>基础配送费（1km）</span>
                        <span>￥10.00</span>
                    </li>
                    <li>
                        <span>等待时间附加费</span>
                        <span>￥5.00</span>
                    </li>
                    <li>
                        <span>距离附加费（3km）</span>
                        <span>￥5.00</span>
                    </li>
                    <li>
                        <span>优惠券</span>
                        <span>￥5.00</span>
                    </li>
                </ul>}
            </div>
            <hr></hr>
            {/* 乘客信息 */}
            <div className='passengerInfo'>
                <p className='title'>乘客信息</p>
                <ul className="info">
                    <li>
                        <span>服务时间</span>
                        <span>现在</span>
                    </li>
                    <li>
                        <span>姓名</span>
                        <span>肥*</span>
                    </li>
                    <li>
                        <span>联系方式</span>
                        <span>********8888</span>
                    </li>
                    <li>
                        <span>备注</span>
                        <span>请尽快过来</span>
                    </li>
                </ul>
            </div>
            {/* 订单信息 */}
            <div className="orderInfo">
                <p className='title'>订单信息</p>
                <ul className="info">
                    <li>
                        <span>订单编号</span>
                        <span>454545454454</span>
                    </li>
                    <li>
                        <span>下单时间</span>
                        <span>2023-12-31 01:01</span>
                    </li>
                </ul>
            </div>
            <Button color='warning'>抢单</Button>
        </div>
    )
}
export default RushBill